import Document from '@cp/src/pages/CaseDetails/components/Documents';
//import BankStatementView from './bankStatement/BankStatementView';

export const DOCUMENTS = 'documents';

export const DEFAULT_PAGE_NUMBER = 1;
export const DEFAULT_PAGE_SIZE = 50;
export const MIN_SEARCH_LENGTH = 3;

export const DOCUMENT_TABS = {
  BANK_STATEMENT: 'bank_statement',
  OTHER_DOCUMENTS: 'other_documents'
};

export const defaultQueryParams = {
  documents: {
    selectedTab: DOCUMENT_TABS.OTHER_DOCUMENTS
  }
};

//commented bank statement here since it was breaking due to cyclic dependency
// we will be deprecating this old version of documents tab in the future
export const DOCUMENT_TABS_KEYS = [
  {
    key: DOCUMENT_TABS.OTHER_DOCUMENTS,
    value: 'All Documents',
    component: <Document />
  }
  // {
  //   key: DOCUMENT_TABS.BANK_STATEMENT,
  //   value: 'Bank Statement',
  //   component: <BankStatementView />
  // }
];

export enum NUMBERS_STATUS {
  EXISTS_AND_VALID = 'EXISTS_AND_VALID',
  EXISTS_AND_INVALID = 'EXISTS_AND_INVALID',
  DOES_NOT_EXIST = 'DOES_NOT_EXIST'
}

export const BANK_STATEMENT_SOURCE = 'BANK_STATEMENT';

export const ADD_NUMBER_AND_INITIATE_CALL_SUCCESS_TOAST_MESSAGE =
  'Phone number added successfully & call has been initiated';

export enum NUMBER_FILTERS {
  ALL_NUMBERS = 'All numbers',
  OTHER_NUMBERS = 'Other numbers'
}
